<template lang="pug">
  .container-fluid
      vm-stepper(v-model='step' @done='saveRecord' save-next-text="Next")
          vm-stepper-header
              vm-stepper-step(step='1' :validate="!$v.form.$invalid" :danger="$v.form.$invalid" :editable="!$v.form.$invalid" :complete='!$v.form.$invalid')
                  | {{$t("strings.user")}}
              vm-divider
              vm-stepper-step(step='2' :validate="!$v.form.$invalid" :danger="$v.form.$invalid" :editable="!$v.form.$invalid" :complete='!$v.form.$invalid')
                    | {{$t("strings.permissions")}}
          vm-stepper-items
              vm-stepper-content(step='1')
                .card
                  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
                    vm-col(vm-justify="center", vm-align="center", vm-w=12)
                      b-form-group
                        vm-input(autofocus :placeholder='$t("users.name_placeholder")' :danger="$v.form.name.$invalid && $v.form.name.$model" :danger-text="$t('validation.required', { attribute: $t('users.name') })" v-model="form.name" :label='$t("users.name")')
                    vm-col(vm-justify="center", vm-align="center", vm-w=12)
                      b-form-group
                        vm-input(:placeholder='$t("users.email_placeholder")' :danger="$v.form.email.$invalid && typeof $v.form.email.$model !== 'undefined'" :danger-text="$t('validation.email', { attribute: $t('users.email') })" v-model="form.email" :label='$t("users.email")' required)
                    vm-col(vm-justify="center", vm-align="center", vm-w=12)
                      b-form-group
                        vm-input(:placeholder='$t("users.password_placeholder")' type="password" :danger="$v.form.password.$invalid && typeof $v.form.password.$model !== 'undefined'" :danger-text="$v.form.password.minLength ? $v.form.password.required ? '' : $t('validation.required', { attribute: $t('users.password') }) : $t('validation.min.string', { attribute: $t('users.password'), min: 4 })" v-model="form.password" :label='$t("users.password")' required)
                    vm-col(vm-justify="center", vm-align="center", vm-w=12)
                      b-form-group
                        vm-input(:placeholder='$t("users.confirm_password_placeholder")' type="password" :danger="$v.form.confirm_password.$invalid && typeof $v.form.confirm_password.$model !== 'undefined'" :danger-text="$t('validation.same', { attribute: $t('users.confirm_password'), other: $t('users.password') })" v-model="form.confirm_password" :label='$t("users.confirm_password")' required)
                    vm-col(vm-justify="center", vm-align="center", vm-w=12)
                      b-form-group
                        vm-select(:placeholder='$t("users.role_placeholder")' :danger="$v.form.role.$invalid && $v.form.role.$model" :danger-text="$t('validation.required', { attribute: $t('users.role') })" v-model="form.role" :label='$t("users.role")')
                          vm-select-item(value="Admin" text="Admin")
                          vm-select-item(value="Manual" text="Manual")
              vm-stepper-content(step='2' :editable="form.role === 'Manual'")
                vm-row(vm-justify="center" vm-w="12" vm-align="center")
                  .permissions(v-if="form.role === 'Manual'")
                    add-permissions-cano(v-if="form.role === 'Manual'")
                  .admin(v-else)
                    img.img(src="@/assets/add_user.png")
                    h1 {{$t("front.role")}}
                    p {{$t("front.role_validate")}}
</template>
<script>
import { required, requiredIf, minLength, maxLength, email, sameAs } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Users')

export default {
  name: 'AddUser',
  components: {
    toogle: () => import('@/components/aditionals/Toogle.vue'),
    AddPermissionsCano: () => import('@/components/aditionals/AddPermissionsCano.vue')
  },
  data: () => ({
    step: 1,
    active: false,
    customer: true,
    form: {
      permissions: []
    }
  }),
  validations () {
    return {
      form: {
        name: {
          required
        },
        email: {
          required,
          email,
          minLength: minLength(4),
          maxLength: maxLength(76)
        },
        password: {
          required: requiredIf((password) => {
            return this.isAdd
          }),
          minLength: minLength(6)
        },
        confirm_password: {
          required: requiredIf((confirmPassword) => {
            return this.form.password
          }),
          sameAsPassword: sameAs('password')
        },
        role: {
          required
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'addUser'
    ]),
    saveRecord () {
      if (this.form.role === 'Manual' && !this.user.permissions[0]) {
        this.$vm.dialog({
          color: 'danger',
          title: this.$t('front.select_permissions'),
          text: this.$t('front.select_permissions')
        })
      } else {
        this.addUser({ user: this.form, permissions: this.user.permissions }).then(() => { this.$router.push({ name: 'users' }) })
      }
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  }
}
</script>

<style lang="scss" scoped>
  .admin {
    height: 25rem;
    text-align: center;
    background: white;
    padding: 20px;
  }
  .img{
    height: 70%;
  }
  .permissions {
    height: calc(120vh - 110px);
    overflow-y: auto;
  }
  .card {
    padding: 20px;
    background: white;
    -webkit-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
    box-shadow: 0px 4px 9px -5px rgba(0,0,0,0.15);
  }
</style>
